import { unref } from 'vue';

const SUPPORTED_SHEETS = new Set(['maintenance_degradation', 'maintenance_intervention']);
const PHOTO_FIELD = /^photos\.file\.(\d+)$/;

export function createMaintenancePhotoDrawingWidget({ sheet, record }) {
    if (!SUPPORTED_SHEETS.has(unref(sheet)?.name)) return null;

    return {
        decorateGalleryItem(item) {
            const match = String(item?.field ?? '').match(PHOTO_FIELD);
            if (!match) return item;

            const photo = (unref(record)?.photos ?? []).find(candidate => String(candidate?.id) === match[1]);
            if (!photo?.drawing) return item;

            return { ...item, drawingSrc: photo.drawing };
        },
    };
}